module.exports = __webpack_public_path__ + "static/media/Vita Award.28b15c09.svg";